<h3 class="ui primary header">
  Export Statement
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<esl-message-toast [(message)]="error"></esl-message-toast>
<esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>

<div class="content">
  <div
    class="ui basic vertical segment"
  >
    <div class="ui form">
      <div class="field">
        <label>Start Date</label>
        <div class="ui fluid input">
          <div class="ui right icon input">
            <i class="calendar icon"></i>
            <input [(ngModel)]="startDate" suiDatepicker [pickerMaxDate]="endDate" [pickerMode]="'date'" [pickerUseNativeOnMobile]="false" />
          </div>
        </div>
      </div>
      <div class="field">
        <label>End Date</label>
        <div class="ui fluid input">
          <div class="ui right icon input">
            <i class="calendar icon"></i>
            <input [(ngModel)]="endDate" [pickerMinDate]="startDate" suiDatepicker [pickerMode]="'date'" [pickerUseNativeOnMobile]="false" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button
      class="ui basic primary button"
      (click)="modal.deny(undefined)"
    >
      Cancel
    </button>
    <button
      class="ui primary button"
      (click)="submit()"
      autofocus
      [disabled]="!startDate ||!endDate"
      [ngClass]="{loading: pending}"
    >
      Export
    </button>
  </div>
</div>
